module.exports = require('react/lib/update');


//////////////////
// WEBPACK FOOTER
// ./~/@allenfang/react-toastr/~/react-addons-update/index.js
// module id = 372
// module chunks = 0